import CreateFetch from '@/common/utils/createFetch';

const api = new CreateFetch();

export const initApi = (authStore, vuexStore) => api.setAdapter({
  unauthorize: () => authStore.signOut(),

  checkReconfiguration: () => vuexStore.dispatch('reconfiguration/CHECK_RECONFIGURATION'),
  checkAccessDisabled: async () => {
    await authStore.checkAccessDisabled();
  },

  getScopedToken: () => authStore.getScopedToken,
});

export default api;
